import * as angular from 'angular';

const tableColumnsMap = {
  order: {enabled: true, order: 1, permission: undefined},
  referenceNumber: {enabled: false, order: 2, permission: undefined},
  agents: {enabled: false, order: 3, permission: undefined},
  resources: {enabled: false, order: 4, permission: undefined},
  billingStatus: {enabled: true, order: 5, permission: undefined},
  shipperAccount: {enabled: true, order: 6, permission: undefined},
  billingAccount: {enabled: true, order: 7, permission: undefined},
  externalId: {enabled: false, order: 8, permission: undefined},
  locations: {enabled: true, order: 9, permission: undefined},
  packages: {enabled: true, order: 10, permission: undefined},
  consolidate: {enabled: true, order: 11, permission: undefined},
  amount: {enabled: true, order: 12, permission: undefined},
  type: {enabled: true, order: 13, permission: undefined},
  ediStatus: {enabled: true, order: 14, permission: undefined},
  invoiceStatus: {enabled: true, order: 15, permission: undefined},
  createdAt: {enabled: true, order: 16, permission: undefined},
  orderCompletedDate: {enabled: false, order: 17, permission: undefined},
  notes: {enabled: false, order: 18, permission: undefined}
}

angular
  .module('bringoz.admin.billing-accounts')
  .constant('billingOrdersConstants', {
    tableColumnsMap: tableColumnsMap
  });
